import { Component, Input, OnInit } from '@angular/core';
import { Filter } from '../models/filter-models';
import { BaseComponent } from '../common/base.component';
import { CampaignComponent } from './campaign/campaign.component';

type ExtraTabType = 'campaign';

@Component({
  selector: 'app-extra-tab',
  templateUrl: './extra-tab.component.html',
  styleUrl: './extra-tab.component.scss',
  imports: [CampaignComponent]
})
export class ExtraTabComponent extends BaseComponent implements OnInit {
  @Input({ required: true }) filter!: Filter;

  extraTab: ExtraTabType = 'campaign';

  ngOnInit(): void {
    const initialUrl = window.location.pathname.split('/')[2];
    if (initialUrl === 'campaign') {
      this.extraTab = 'campaign';
    }
  }

  selectTab(tab: ExtraTabType): void {
    this.extraTab = tab;
    window.history.replaceState({}, '', `/info/${tab}`);
  }
}
